<div class="flex flex-col gap-2 rounded-lg">
  @if (definitionsExist()) {
    <button
      (click)="goToProcessClicked.emit()"
      class="text-blue-500 font-semibold text-l inline-flex items-center gap-x-2"
      flxButton
      variant="text"
      data-testid="info-go-to-process-definition-btn"
    >
      <i class="ph ph-arrow-circle-up-right"></i>
      Go to process definition
    </button>
  }
  <div class="flex flex-row gap-2 items-center h-[30px]">
    <span class="text-neutral-900 font-semibold">{{ type() }}:</span>
    <span class="text-neutral-600">
      {{ appName() }}
    </span>
  </div>
  @if (instanceFromBuild()) {
    <div class="flex flex-row gap-2">
      <span class="text-neutral-900 font-semibold">Build:</span>
      <flx-build-tag
        [appName]="appName()"
        [buildTagVersion]="buildTagVersion()"
        size="xs"
      />
    </div>
  } @else {
    <div class="flex flex-row gap-2 items-center h-[30px]">
      <span class="text-neutral-900 font-semibold">Branch:</span>
      <div class="flex flex-row items-center gap-x-2">
        <flx-branch-state-icon
          [status]="buildStatusAtStart()"
          [branchName]="branchName()"
        ></flx-branch-state-icon>
        <flx-branch-name [branchName]="branchName()"></flx-branch-name>
        <flx-branch-state [status]="buildStatusAtStart()"></flx-branch-state>
      </div>
    </div>
    <div class="flex flex-row gap-2 items-center h-[30px]">
      <span class="text-neutral-900 font-semibold">{{ type() }} version id:</span>
      <span class="text-neutral-600 text-xs">
        {{ buildId() }}
      </span>
    </div>
  }

  <div class="flex flex-row gap-2 items-center h-[30px]">
    <span class="text-neutral-900 font-semibold">Started:</span>
    <span class="text-neutral-600 text-xs">
      {{ dateStarted() }}
    </span>
  </div>
  <div class="flex flex-row gap-2 items-center h-[30px]">
    <span class="text-neutral-900 font-semibold">Ended:</span>
    <span class="text-neutral-600 text-xs">
      {{ dateFinished() }}
    </span>
  </div>
</div>
